// EL AVISO DE UNA LÍNEA BAJO LA CABECERA · DIRECTRIZ-PWA F1 (DISENO-F1 §9.6,
// R-PWA-7). Solo en pantalla táctil, solo si TEGO no está instalada y el
// worker ya está registrado o listo; «Ahora no» lo guarda 14 días. Va en
// flujo, nunca fijo: no tapa ningún botón (M6). A 320 px los botones bajan
// a una segunda línea (`flex-wrap`) sin salirse (M1).
import { useState } from 'react';
import { Smartphone } from 'lucide-react';
import { useAuth } from '../../lib/contextoAuth';
import { useInstalacion } from './useInstalacion';
import { esTactil } from './instalacion';
import { cerradoHacePoco, anotarCierre } from './plazoAviso';

const BOTON = 'min-h-11 px-3 rounded-lg text-sm font-semibold focus:outline-none focus:ring-2 focus:ring-[var(--color-marca)]';

export default function AvisoInstalar({ irA, activa }) {
  const { usuario } = useAuth();
  const tactil = esTactil();
  // La persistencia se pide desde aquí una vez por aparato, solo con sesión
  // y en pantalla táctil (R-PWA-9).
  const { estado, worker } = useInstalacion({ pedir: !!usuario && tactil });
  const [cerradoAhora, setCerradoAhora] = useState(false);
  // Se lee cada vez: lo único que lo escribe es «Ahora no», desde aquí.
  const cerrado = cerradoAhora || cerradoHacePoco();

  const workerVivo = worker.estado === 'listo' || worker.estado === 'registrado';
  if (!usuario || !tactil || estado === 'instalada' || !workerVivo || cerrado || activa === 'instalar-tego') return null;

  function ahoraNo() {
    anotarCierre();
    setCerradoAhora(true);
  }

  return (
    <div role="status" className="bg-[var(--color-marca-suave)] text-[var(--color-marca-oscura)] px-4 py-2 flex flex-wrap items-center gap-x-3 gap-y-2">
      <Smartphone className="h-5 w-5 shrink-0" aria-hidden="true" />
      <p className="min-w-0 flex-1 basis-48 text-sm">
        <strong>Instala TEGO en tu teléfono</strong> para abrirla desde un icono y seguir trabajando sin señal.
      </p>
      <div className="flex flex-wrap gap-2">
        <button type="button" onClick={() => irA?.('instalar-tego')} className={`${BOTON} bg-[var(--color-marca)] text-white`}>Ver cómo</button>
        <button type="button" onClick={ahoraNo} className={`${BOTON} border border-[var(--color-marca-borde)] bg-white text-[var(--color-marca-oscura)]`}>Ahora no</button>
      </div>
    </div>
  );
}
